import React from "react";
import PropTypes from "prop-types";

const LocationList = ({ mapData, parentIndex }) => (
  <tr key={parentIndex} style={{ fontSize: 12 }}>
    <td>{parentIndex + 1}</td>
    <td style={{ fontSize: 12 }}>{mapData.locationName}</td>
    {mapData.dailyDepartment.map(
      (departmentNumber, departmentIndex) => (
        <td key={departmentIndex} className="text-center">
          {departmentNumber.total}
        </td>
      )
    )}
    <td className="text-center">{mapData.totalPresent}</td>
  </tr>
);

LocationList.propTypes = {
  parentIndex: PropTypes.any,
  mapData: PropTypes.array
};

export default LocationList;
